import { ReactNode } from 'react';
import { PopperPlacementType } from '@mui/material/Popper';
import { GoalFormField } from './clients-entity';

export interface PlanOverviewTabItem {
    label: ReactNode;
    count?: number;
    disabled?: boolean;
    hidden?: boolean;
    tooltipKey?: string;
    tooltipMessage?: ReactNode;
    tooltipPlacement?: PopperPlacementType;
    tooltipWidth?: number;
    [key: string]: any;
}

export interface PlanOverviewTabProps {
    value: number;
    // eslint-disable-next-line no-unused-vars
    onChange: (event: React.SyntheticEvent, newValue: number) => void;
    tabItems?: PlanOverviewTabItem[];
    isPlanDetailsEnhancementEnabled?: boolean;
    ftdsBadge?: boolean;
    showMappingGuideLink?: boolean;
    flat?: boolean;
}

export interface SecondaryTabsProps {
    value: number;
    // eslint-disable-next-line no-unused-vars
    onChange: (event: React.SyntheticEvent, newValue: number) => void;
    // eslint-disable-next-line no-unused-vars
    onEditPlan: (goalIndex: number) => void;
    selectedGoalIndex: number;
    showSecondTab?: boolean;
    // isEditing: boolean;
    // onExit: () => void;
}

export interface GoalOverviewContentProps {
    formFields?: GoalFormField[]; // optionally for storybook purposes
    selectedGoalIndex: number;
}

export interface PortfolioDetailAndProjectionsContentProps {
    formFields?: GoalFormField[]; // optionally for storybook purposes
    selectedGoalIndex: number;
}

export enum TabType {
    // eslint-disable-next-line no-unused-vars
    GoalOverview = 0,
    // eslint-disable-next-line no-unused-vars
    PortfolioDetail = 1
}

export interface GoalEditComparisonProps {
    selectedGoalIndex: number;
}

export interface ComparisonSide {
    value?: string;
    description?: string;
    items?: CompositionEntry[];
    renderCustom?: () => JSX.Element;
    showSlider?: boolean;
    sliderValue?: number;
    sliderMin?: number;
    sliderMax?: number;
    isLargeCard?: boolean;
    step?: number;
    originalDate?: string; // DD-MM-YYYY format for date fields
    // eslint-disable-next-line no-unused-vars
    onSliderChange?: (value: number) => void;
}

export interface ComparisonRow {
    key: string;
    label: string;
    showInfoIcon?: boolean;
    infoTooltipContent?: string;
    original: ComparisonSide;
    adjusted: ComparisonSide;
}

export interface AnnualContributionDetails {
    amount: number;
    realisationDt?: string;
    isFinalYear?: boolean;
}

export interface CompositionEntry {
    label: string;
    value: string;
}

export interface EditableSliderProps {
    value: number;
    min: number;
    max: number;
    /* eslint-disable no-unused-vars */
    formatValue: (val: number) => string;
    onChange: (value: number) => void;
    /* eslint-enable no-unused-vars */
    fieldType: 'currency' | 'date';
    originalDate?: string; // DD-MM-YYYY format for date fields
    step?: number;
}

export interface ComparisonRowItemProps {
    row: ComparisonRow;
    /* eslint-disable no-unused-vars */
    renderSlider: (
        value: number,
        min: number,
        max: number,
        formatValue: (val: number) => string,
        onChange: (value: number) => void,
        fieldType: 'currency' | 'date',
        originalDate?: string,
        step?: number
    ) => JSX.Element;
    /* eslint-enable no-unused-vars */
}
